module.exports = __webpack_public_path__ + "static/media/facebook_logo.a444ccd6.png";